import {Drawer} from '@logistics-frontend/blocks/legacy'
import {Breakpoints, DrawerProps} from '@logistics-frontend/blocks/legacy/drawer/types'
import React from 'react'

import {useMarginRef} from '../margin-provider'
import {classes} from './DrawerMobile.classes'

const DEFAULT_BREAKPOINTS_MOBILE: Record<Breakpoints, number> = {
  [Breakpoints.FULL]: 0, // полноразмерная шторка
  [Breakpoints.LARGE]: 0.4, // большая шторка
  [Breakpoints.MEDIUM]: 0.36, // средняя шторка(станадртная)
  [Breakpoints.MINIMUM]: 0.8, // слегка видная шторка
  [Breakpoints.HIDDEN]: 1.2, // спрятанная шторка за пределами экрана
}

const BREAKPOINTS_MOBILE: DrawerProps['breakpoints'] = {
  darken: Breakpoints.MEDIUM,
}

const DrawerMobile: React.FC<React.PropsWithChildren<unknown>> = ({children}) => {
  const ref = useMarginRef<HTMLDivElement>(el => ({
    bottom: window.innerHeight - el.getBoundingClientRect().y,
  }))

  return (
    <Drawer
      ref={ref}
      breakpoints={BREAKPOINTS_MOBILE}
      breakpointsCoefficients={DEFAULT_BREAKPOINTS_MOBILE}
      className={classes.container}
      closable={false}
      expanderType="none"
    >
      {children}
    </Drawer>
  )
}

export default DrawerMobile
